<script setup lang="ts">
const props = withDefaults(defineProps<{
  label?: string
  description?: string
  modalName?: string
  modalTitle?: string
  disableModal?: boolean
}>(), {
  label: 'Show info',
  description: '',
  modalName: 'dialog-info',
  modalTitle: 'Show info',
  open: false,
})

const modalName = `modal-${props.modalName}`
const modal = useUiDialog(modalName)

function openModal() {
  if (!props.disableModal) {
    modal.open()
  }
}

onUnmounted(() => {
  modal.close()
})
</script>

<template>
  <div class="spec-tab__item">
    <button
      class="spec-tab__button"
      type="button"
      @click="openModal()"
    >
      <span class="spec-tab__label">{{ $t(label) }}</span>
      <span class="spec-tab__description">{{ $t(description) }}</span>
      <span class="spec-tab__icon">
        <Icon
          v-if="!disableModal"
          name="icon:arrow"
          class="icon icon--arrow icon--arrow-right"
        />
      </span>
    </button>

    <LazyUiDialog
      :name="modalName"
      class="spec-tab__dialog"
      :class="modalName"
      dialog-type="responsive"
    >
      <template #dialogHeader>
        {{ $t(modalTitle) }}
      </template>

      <slot>Details</slot>
    </LazyUiDialog>
  </div>
</template>

<style>
@import url("~layers/app/components/Product/SpecButton.css");
</style>
